BSS_B2B.fixProductMetaField = (responseProducts, handleUrls) => {
  if (responseProducts.length != handleUrls.length) {
    handleUrls.forEach((item) => {
      if (!responseProducts.some((product) => item.includes(product.id))) {
        let productId = +item.match(/\d/g).join("");
        responseProducts.push({
          id: productId,
        });
      }
    });
  }
  return responseProducts;
};
